import { render, staticRenderFns } from "./DialogHeadCount.vue?vue&type=template&id=67b5e520&scoped=true&"
import script from "./DialogHeadCount.vue?vue&type=script&lang=js&"
export * from "./DialogHeadCount.vue?vue&type=script&lang=js&"
import style0 from "./DialogHeadCount.vue?vue&type=style&index=0&id=67b5e520&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b5e520",
  null
  
)

export default component.exports